import { Services, getServicePathToAPI, projectName } from '@sigma-frontend-libs/commons'
import Macro from '@sigma-legacy-libs/cache'
import { defaultStringParser } from '@sigmasms/commons'
import { ConditionsCheckFunctions, ConditionsLegacyCompatible, EConditionsTags } from '@sigmasms/conditions'

import { request } from '../'
import { macroCacheOptions } from '../constants'

const Cache = new Macro(macroCacheOptions)

const cachedFind = Cache.wrapWithCache(async (key, service, params) => {
  const pathToAPI = getServicePathToAPI(service)

  return await request.find(pathToAPI, undefined, params?.query)
})

class ConditionsFrontendCheckFunctions extends ConditionsCheckFunctions {
  async checkInContactLists(phone, ListId) {
    const params = {
      query: {
        phone,
        ListId
      }
    }
    const key = [ projectName, Services.contacts, 'find', JSON.stringify(params) ].filter(Boolean).join(':')
    const data = await cachedFind(key, Services.contacts, params) || {}

    return data?.total > 0
  }
}

const conditionsCheckFunctions = new ConditionsFrontendCheckFunctions({
  stringParser: defaultStringParser
})

const conditionsLegacyCompatible = new ConditionsLegacyCompatible({
  checkFunctionClass: conditionsCheckFunctions
})

const conditionValueTypes = {
  [EConditionsTags.text]: 'string',
  [EConditionsTags.recipient]: 'string',
  [EConditionsTags.sender]: 'array',
  [EConditionsTags.mccmnc]: 'object',
  [EConditionsTags.contactList]: 'array',
  [EConditionsTags.type]: 'array',
  [EConditionsTags.group]: 'array',
  [EConditionsTags.messagePattern]: 'array',
  [EConditionsTags.keywords]: 'array',
  [EConditionsTags.yulore]: 'array'
}

// https://sigmasms.slack.com/archives/C03RRLZB8MP/p1772452286899019
const conditionsTags = [
  EConditionsTags.text,
  EConditionsTags.recipient,
  EConditionsTags.mccmnc,
  EConditionsTags.sender,
  EConditionsTags.contactList,
  EConditionsTags.type,
  EConditionsTags.group,
  EConditionsTags.messagePattern,
  EConditionsTags.keywords,
  EConditionsTags.yulore
]

const resolveConditionTagFromLegacyCondition = legacyCondition => {
  try {
    const { tag } = conditionsLegacyCompatible.standardizeCondition(legacyCondition)
    if (conditionsTags.includes(tag)) {
      return tag
    }

    return undefined
  } catch (error) {
    return undefined
  }
}

const resolveConditionTag = tagOrPath => {
  if (!tagOrPath) {
    return undefined
  }

  return (
    resolveConditionTagFromLegacyCondition({ tag: tagOrPath }) ||
    resolveConditionTagFromLegacyCondition({ path: tagOrPath })
  )
}

const validateConditionValue = (conditionTag, conditionValue) => {
  if (conditionValueTypes[conditionTag] === 'array') {
    if (!Array.isArray(conditionValue) || conditionValue.length === 0) {
      return false
    }
  }

  if (conditionTag === EConditionsTags.mccmnc) {
    if (!conditionValue || typeof conditionValue !== 'object') {
      return false
    }
    if (!Object.keys(conditionValue).length) {
      return false
    }
  }

  try {
    return conditionsLegacyCompatible.filterConditionsArray([
      {
        tag: conditionTag,
        value: conditionValue
      }
    ]).length > 0
  } catch (error) {
    return false
  }
}

const checkLegacyCondition = (legacyCondition, legacyTestingValue) => {
  return conditionsLegacyCompatible.checkConditions(legacyTestingValue, [ legacyCondition ])
}

export { checkLegacyCondition, conditionValueTypes, conditionsTags, resolveConditionTag, resolveConditionTagFromLegacyCondition, validateConditionValue }

